import type { PaginatedResponse } from '@repo/types/pagination';
import type { ParentChildAttendance } from '@repo/types/parent';
import type { UserPublic } from '@repo/types/users';

import type { GetChildListParams } from './parentService';
import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * A page of attendance records per linked child, aggregated.
 *
 * `paramsFor` derives each child's query — children paginate independently, so
 * `page` typically differs per child while the filters are shared.
 */
export function useGetChildrenAttendance(
  children: UserPublic[],
  paramsFor?: (child: UserPublic) => GetChildListParams,
  enabled = true
): ChildrenResourceResult<PaginatedResponse<ParentChildAttendance>> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_ATTENDANCE, child.id, paramsFor?.(child)],
    (child) => ParentService.getChildAttendance(child.id, paramsFor?.(child)).then((response) => response.data),
    enabled
  );
}
